/* eslint-disable padding-line-between-statements */

import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useEffect, useCallback, useContext, useState } from 'react';
import { TwiaBillingService }  from 'ent-capability-policybilling';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { TranslatorContext } from "@jutro/locale";
import moment from 'moment';
import { LocaleService } from 'gw-portals-i18n-react';
// import moment from 'moment';
import _ from 'lodash';
import messages from './SetupAutomaticPaymentComponent.messages';
import metadata from './SetupAutomaticPaymentComponent.metadata.json5';
import styles from './SetupAutomaticPaymentComponent.module.scss';


function SetupAutomaticPaymentComponent(props) {
    const { 
        payFrom,
        invoiceStream,
        streamPublicId,
        // accountNumber,
        policyNumber, // needed
        postPayOperation, // boolean value
        authHeader, 
        paymentInstrumentId,
        onSelectedInstrumentChange ,  // prop from parent
        paymentInstruments, // prop from parent
        // paymentPlanIn, // get the value from parent (billingSummary)
          history
        // For pass thru values for Modal windows.
        // onResolve,
        // onReject,
        // onAfterClose
    } = props;
    
    const translator = useContext(TranslatorContext);
    const [loading, setLoading] = useState(false);
   //  const [tokenId, setTokenId] = useState(null);
    const [paymentInstrument, setPaymentInstrument] = useState({});
    const [autoPayData, setAutoPayData] = useState({});
   // //// const [, updateState] = useState();
    const { showAlert,  showConfirm } = useModal();
  
     const generateModalErrorOrWarning = useCallback((messageHeader, messageDescription, statusType, buttonLabelText) => showAlert({
            title: translator(messageHeader),
            message: translator(messageDescription),
            status: statusType,
            icon: 'mi-error-outline',
            confirmButtonText: buttonLabelText ? commonMessages.close : commonMessages.ok
        }), [showAlert, translator]);

        const generateModalErrorOrWarningConfirm = useCallback((messageHeader, messageDescription, statusType) => showConfirm({
            title: translator(messageHeader),
            message: translator(messageDescription),
            status: statusType,
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,  // buttonLabelText ? commonMessages.close : commonMessages.ok,
            cancelButtonText: commonMessages.cancelModel
        }), [showConfirm, translator]);

      
    const cancelPayment = () => {
        const e = autoPayData && autoPayData.enabled;
        const title = e ? translator(messages.cancelAutoPayEditTitle) : translator(messages.cancelAutoPaySetupTitle);
        const body = e ? translator(messages.cancelAutoPayEditBody) : translator(messages.cancelAutoPaySetupBody);
        
        // eslint-disable-next-line consistent-return
        generateModalErrorOrWarningConfirm(title, body, 'warning').then((results) => { 
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }        
            if ((!autoPayData.enabled) && !_.isEmpty(paymentInstrument)){
                // unselect the selected payment instrument
                setPaymentInstrument(null);
                onSelectedInstrumentChange(null);
            }
        });
    };

    const autoPayEnabled = () =>  paymentInstrument && paymentInstrument.token;

    const enableButtonLabel = () => autoPayData && autoPayData.enabled ? 
            translator(messages.updateAutoPay) : 
            translator(messages.turnOnAutoPay)


    const enableAutoPay = () => {
        const e = autoPayData && autoPayData.enabled;
        const title = e ? translator(messages.confirmAutoPayEditTitle) : translator(messages.confirmAutoPay);
        const body = e ? translator(messages.confirmAutoPayEditBody) : translator(messages.confirmAutoPaySetupBody);
        
        showConfirm({title, message:body})
        // eslint-disable-next-line consistent-return
        .then((results) => { 
            if (results === 'confirm') {
                const piPubID = paymentInstrumentId;
                const isPubID = streamPublicId;   
                TwiaBillingService.payBalanceAndEnableAutoPay(piPubID, isPubID, authHeader)
                .then(() => {
                    setLoading(false);   
                    if (postPayOperation) {
                        postPayOperation(paymentInstrument);
                    }                           
                    invoiceStream.autoPayEnabled = true;
                    history.replace(`/billing-summary?streamId=${policyNumber}&enableAutoPay=${invoiceStream.autoPayEnabled}`);      
                    window.location.reload();           
                })
                .catch(() => {
                    if (e){
                        generateModalErrorOrWarning('Update Error', 'Unable to Edit', 'error');
                    }                     
                })
            } else   if (results === 'cancel' || results === 'close') {
                return _.noop();
            }                  
        });
    };

    const disableAutoPay = () => {
        const autoPayPlan = _.get(autoPayData, 'paymentPlanID') === 'payment_plan:11';
        // const e = autoPayData && autoPayData.enabled;
        const title = translator(messages.turnOffAutoPayTitle);
        // US20222 different messages for turning off autopay on the autopay plan
        const body = autoPayPlan
            // eslint-disable-next-line react/react-in-jsx-scope
            ?  <div className={styles.modalBodyStyle}>{translator(messages.turnOffAutoPayBodyWithAutoDraftPlan)}</div>
            :  translator(messages.turnOffAutoPayBody);
        
        showConfirm({
            title,
            message: body,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: messages.cancel,
            className: styles.jut__Button__filled,
        // eslint-disable-next-line consistent-return
        }).then( (results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            TwiaBillingService.disableAutoPay(streamPublicId, authHeader)
            .then(() => {
                setLoading(false);
                if (postPayOperation) {
                    postPayOperation();
                }
                invoiceStream.autoPayEnabled = false;               
                const confirmTitle = translator(messages.confirmTurnOffAutoPaySubject);               
                const confirmBody = translator(messages.confirmTurnOffAutoPayBody,  {policy: policyNumber});               
                generateModalErrorOrWarning(confirmTitle, confirmBody, 'warning', 'closeBtnLabel')               
                .then((res) => {
                    if (res === 'confirm' || res === 'close') {    
                        history.replace(`/billing-summary?streamId=${policyNumber}&enableAutoPay=${invoiceStream.autoPayEnabled}`);              
                        window.location.reload();
                    }
                });
            });
        });
    };

    const getFormattedDate = (
        (aDate) => {
            if (_.isUndefined(aDate)){
                return undefined;
            }       
           const bDate = moment(aDate);
           return bDate.format('MMM DD, YYYY');          
        });

    const getAutoPayData = useCallback(() => {
        if (authHeader) {
            const pis = paymentInstruments?.filter(pi => pi.singleUse === false);
            TwiaBillingService.getInvoiceStreamAutoPayData(streamPublicId, true, authHeader).then(apd => {
                setAutoPayData(apd);

                let instr;

                if (!_.isUndefined(apd.autoPayInstrument)) {
                    if ( !paymentInstrumentId &&  apd.autoPayInstrument) {
                        instr = pis.find(pi => pi.publicID === apd.autoPayInstrument.publicID);
                    } else {
                        instr = pis.find(pi => pi.publicID === paymentInstrumentId);
                    }

                    setPaymentInstrument(instr);
                    onSelectedInstrumentChange(instr?.publicID);
                }

                if (!_.isEmpty(paymentInstrumentId) && !_.isEmpty(paymentInstruments)) {
                    setPaymentInstrument(paymentInstruments.find(pi => pi.publicID === paymentInstrumentId));
                }
            })
        }
    }, [authHeader, onSelectedInstrumentChange, paymentInstrumentId, paymentInstruments, streamPublicId]);
  
    useEffect(() => {
        LocaleService.register();
        // set auto pay data
        getAutoPayData();
    }, [paymentInstrument, payFrom, getAutoPayData, paymentInstrumentId]);

    const overrideProps = {
        makePaymentLoader: {
            visible: loading
        },
        makePaymentSummaryGrid: {
            visible: true
        },       
        nextDraftDateValueId:{
            content: getFormattedDate(autoPayData.nextPaymentDueDate)           
        },       
        paymentPlanValueId: {
            content: autoPayData.paymentPlan            
        },
        makePaymentButton:{
            disabled: !autoPayEnabled(),
            content: enableButtonLabel()
        },
        disabledAutoPayButton:{
            visible: autoPayData.enabled
            // className: styles.buttons
        },
        futurePaymentTextId: {
            visible: true, // this is visible for both Setup and Edit Autopay scenarios.
            content: translator(messages.futurePaymentsDraftedOnInvoiceDueDate),
            className: styles.validationMsgDisplay
        },
        autoPayDataEnabledId:{
            visible : autoPayData.enabled,
            content: translator(messages.anyChangesToAutoPay),
            className: styles.validationMsgDisplay
            
        },
        autoPayPastDueDataId: {
            visible: autoPayData.hasPastDue,
            content: translator(messages.invoicesWillbeDraftedImmediately),
            className: styles.validationMsgDisplayInRed
        }      
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            cancelPayment,
            enableAutoPay,
            enableButtonLabel,
            disableAutoPay
        }
    };

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <MetadataContent
            uiProps={metadata.componentContent}
            model={autoPayData}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

export default SetupAutomaticPaymentComponent;
